import { describeRoute } from "./describeRoute";

const ANCHOR_ATTRIBUTES = ["data-track", "data-automation", "data-track-workflow", "data-track-panel", "data-x-origin", "data-track-chart", "data-track-row"];
const ANCHOR_SELECTOR = ANCHOR_ATTRIBUTES.map((attribute) => `[${attribute}]`).join(",");
const COMPONENT_TYPES = ["button", "dropdown", "table", "chart", "panel", "pageTab", "feature"];

export const KIND_SELECTORS = {
  button: "button, a, [role='button'], .btn, input[type='button'], input[type='submit']",
  dropdown: "[class*='__control']",
  chart: ".highcharts-container, .js-plotly-plot, canvas",
  pageTab: ".nav-tabs .nav-link, .nav-pills .nav-link, [role='tab']",
  table: "[data-track-row]",
};

const currentPage = () => (typeof window === "undefined" ? "" : describeRoute(window.location.pathname).page);

const readAnchor = (element) => {
  for (let index = 0; index < ANCHOR_ATTRIBUTES.length; index += 1) {
    const value = element.getAttribute(ANCHOR_ATTRIBUTES[index]);
    if (value && value.trim()) return value.trim();
  }
  return "";
};

export const isComponentType = (type) => COMPONENT_TYPES.includes(type);

export const namedComponentId = (type, name, page = currentPage()) => `${page}|${type}|${name || "unnamed"}`;

export const componentId = (element, type, name, named, page = currentPage()) => {
  if (named && name && name !== "unnamed") return namedComponentId(type, name, page);
  if (!element || typeof element.closest !== "function") return namedComponentId(type, name, page);
  const anchor = element.parentElement ? element.parentElement.closest(ANCHOR_SELECTOR) : null;
  const scope = anchor || element.ownerDocument.body;
  const selector = KIND_SELECTORS[type];
  const kin = selector ? Array.from(scope.querySelectorAll(selector)) : [];
  const position = kin.indexOf(element) + 1;
  return `${page}|${type}|${anchor ? readAnchor(anchor) : "page"}|${position || 0}`;
};

export default componentId;
